import React, { useEffect } from "react";
import { Button, Snackbar, TextField, Alert } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useForm, Controller } from "react-hook-form";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";

import { auth, registerWithEmailAndPassword } from "../../firebase";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2),
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "300px",
    },
    "& .MuiButtonBase-root": {
      margin: theme.spacing(2),
    },
  },
}));

const Register = () => {
  const classes = useStyles();
  const { handleSubmit, control } = useForm();
  const [user, loading] = useAuthState(auth);
  const [open, setOpen] = React.useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (loading) {
      return;
    }
    if (user) {
      navigate("/");
    }
  }, [user, loading, navigate]);

  const onSubmit = async (data) => {
    registerWithEmailAndPassword(data.name, data.email, data.password).then((error) => {
		if (error) {
			setOpen(true);
		}
	});
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
		<>
			<Snackbar
				anchorOrigin={{ vertical: "top", horizontal: "right" }}
				open={open}
				autoHideDuration={3000}
				onClose={handleClose}
			>
				<Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
					Invalid email / passord.
				</Alert>
			</Snackbar>
			<form className={classes.root} onSubmit={handleSubmit(onSubmit)}>
				<Controller
					name="name"
					control={control}
					defaultValue=""
					render={({ field: { onChange, value }, fieldState: { error } }) => (
						<TextField
							label="Name"
							variant="filled"
							value={value}
							onChange={onChange}
							error={!!error}
							helperText={error ? error.message : null}
							type="text"
						/>
					)}
					rules={{ required: "Name required" }}
				/>
				<Controller
					name="email"
					control={control}
					defaultValue=""
					render={({ field: { onChange, value }, fieldState: { error } }) => (
						<TextField
							label="Email"
							variant="filled"
							value={value}
							onChange={onChange}
							error={!!error}
							helperText={error ? error.message : null}
							type="email"
						/>
					)}
					rules={{ required: "Email required" }}
				/>
				<Controller
					name="password"
					control={control}
					defaultValue=""
					render={({ field: { onChange, value }, fieldState: { error } }) => (
						<TextField
							label="Password"
							variant="filled"
							value={value}
							onChange={onChange}
							error={!!error}
							helperText={error ? error.message : null}
							type="password"
						/>
					)}
					rules={{ required: "Password required" }}
				/>
				<div>
					<Button type="submit" variant="contained" color="primary">
						Register
					</Button>
				</div>
			</form>
		</>
  );
};

export default Register;
